import { AxiosResponse } from 'axios';
import api from './api';
import { Device } from '../types/device';

function path(endPath: string = ''): string {
    return `/device${endPath}`;
}
export class DeviceService {
    static async byNode(nodeId: number): Promise<AxiosResponse> {
        return api.get(path(`/${nodeId}`));
    }

    static async byId(deviceId: number): Promise<AxiosResponse<Device>> {
        return api.get(`/device/node/${deviceId}`);
    }

    static async allByNode(nodeId: number): Promise<AxiosResponse> {
        return api.get(path(`/all/${nodeId}`));
    }

    static async add(device: Device): Promise<AxiosResponse> {
        return api.put(path(), device);
    }

    static async move(device: Device): Promise<AxiosResponse> {
        return api.post(path(), device);
    }
}
